<template>
  <div class="admin-access-log-page row-block" :style="{ minHeight: minHeight }">
    <div class="filter-container" :style="{ width: '250px' }">
      <adminFilter
        :minHeight="minHeight"
        :disabled="false"
        :title="'會員操作記錄搜尋'"
        :filters="{
          init: init,
          options: filterOptions
        }"
        @changeFilters="(c, search) => { filters = c; search && searchDatas(c) }"
      ></adminFilter>
    </div>
    <div class="main-container row-block" :style="{ flex: 1, height: minHeight }">
      <div v-if="onSearch" class="mask center-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <!-- <img :src="require('../../assets/images/loading.gif')"> -->
        <img :src="require('../../assets/images/upload.svg')" alt="">
      </div>
      <div class="main-block col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
        <div class="title-container row-block">
          <div class="title">會員操作記錄</div>
          <div :style="{ flex: 1 }"></div>
          <button type="button" name="button" class="main-button option-button update" @click="e => exportExcel()">
            <span>匯出excel</span>
          </button>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="table-feild col-block" :style="{ flex: 1 }">
          <div class="table-container col-block" :style="{ height: '50px' }">
            <div class="thead default-shadow">
              <div class="tr row-block">
                <div
                  v-for="(option, index) in tableOptions"
                  :key="index"
                  class="th row-block"
                  :class="option.class"
                  :style="option.width ? { width: option.width } : { flex: 1 }"
                  @click="e => option.sort !== false && tableSortBy(option.value)"
                >
                  <span>{{ option.title }}</span>
                  <div :style="{ width: '5px' }"></div>
                  <i v-if="option.sort !== false" :class="['fa', 'fa-sort' + (sort.order[sort.value.indexOf(option.value)] || '')]" aria-hidden="true"></i>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-container col-block sub-shadow" :style="{ flex: 1 }">
            <div class="tbody" :style="{ flex: 1 }">
              <div :style="{ height: 0 }">
                <div class="tr row-block" v-for="(report, cindex) in accessLogs" :key="cindex">
                  <div class="container-block row-block">
                    <div
                      v-for="(option, index) in tableOptions"
                      :key="index"
                      class="td row-block"
                      :class="option.class"
                      :style="option.width ? { width: option.width } : { flex: 1 }"
                    >
                      <span :title="(option.display || (x => x))(report[option.value], cindex)" :style="(option.style || (() => {}))(report[option.value])">{{ (option.display || (x => x))(report[option.value], cindex) || '--' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page-container center-block">
            <pageButtons
              v-if="pageData.total"
              :default="pageData.selectedPage"
              :display="pageData.display"
              :total="pageData.total"
              :buttonRange="pageData.buttonRange"
              @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
            ></pageButtons>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { API_ROOT } from '../../api/config'
import { getProductByCategorys, getAdminAccessLogs } from '../../api'
import adminFilter from '../../components/admin/filter'
import pageButtons from '../../components/tool/pageButtons'
import routeLoading from '../../mixins/routeLoading'
import toastMethods from '../../mixins/toastMethods'
import { dateFormat, downloadFile } from '../../constants/global/util'

export default {
  components: {
    adminFilter,
    pageButtons
  },
  mixins: [
    routeLoading,
    toastMethods
  ],
  props: {
    minHeight: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      accessLogs: [],
      productByCategorys: [],
      init: {},
      filters: {},
      onSearch: false,
      pageData: {
        selectedPage: 1,
        display: 12,
        total: null,
        buttonRange: 7
      },
      sort: {
        value: ['created_at'],
        order: ['-desc']
      }
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    moduleOptions () {
      return [
        { title: '市場吸引力', value: 'market_attractiveness' },
        { title: '單一國市場吸引力', value: 'single_country_market_attractiveness' },
        { title: '市場競爭力', value: 'market_competitiveness' },
        { title: '單一國市場競爭力', value: 'single_country_market_competitiveness' },
        { title: '零售價格分析', value: 'product_prices' }
      ]
    },
    categoryOptions () {
      return [
        ...Object.keys(this.productByCategorys).map(category => ({ title: category, value: category })),
        { title: '其他', value: '其他' }
      ]
    },
    productOptions () {
      return [
        ...Array.prototype.concat.apply([], Object.entries(this.productByCategorys).map(([category, products]) => Object.entries(products).map(([code, product]) => ({ title: product.chinese_name, value: code, type: product.product_type, category: category })))),
        { title: '其他', value: '其他', type: '其他', category: '其他' }
      ]
    },
    fileTypeOptions () {
      return [
        { title: '資料表 (一般)', value: 'normal_data_sheet' },
        { title: '資料表 (進階)', value: 'advanced_data_sheet' },
        { title: 'xy散佈圖', value: 'xy_scatter_diagram' },
        { title: '泡泡圖', value: 'bubble_chart' },
        { title: '累積長條圖', value: 'cumulative_bar_graph' },
        { title: '雷達圖', value: 'radar_chart' },
        { title: '原始數據', value: 'raw_data' }
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    // static
    filterOptions () {
      return [
        {
          title: '日期起始與結束',
          value: 'time',
          type: 'date',
          range: [null, dateFormat(new Date(), 'yyyy-MM-dd')],
          placeholder: () => ['請選擇起始日', '請選擇結束日']
        },
        {
          title: '分析模組',
          value: 'module',
          type: 'select',
          options: this.moduleOptions,
          placeholder: () => '請選擇分析模組'
        },
        {
          title: '產品類別',
          value: 'category',
          type: 'select',
          options: this.categoryOptions,
          placeholder: () => '水果、蔬菜、農業機械...等',
          onChange: (value, conditions) => {
            setTimeout(() => {
              this.init = {
                ...this.init,
                ...conditions,
                product_code: ''
              }
            })
          }
        },
        {
          title: '產品名稱',
          value: 'product_code',
          type: 'select',
          options: this.productOptions,
          optionDisplay: result => option => option.category === result.category,
          placeholder: () => '請選擇產品'
        },
        {
          title: '目標國家',
          value: 'partner',
          type: 'datalist',
          lists: value => this.countryOptions.map(option => option.title),
          options: this.countryOptions,
          placeholder: () => '請選擇國家',
          onChange: value => {
            if (value && !this.countryOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                partner: ''
              }
            }
          }
        },
        {
          title: '競爭國家',
          value: 'countries',
          type: 'datalist',
          lists: value => this.countryOptions.map(option => option.title),
          options: this.countryOptions,
          placeholder: () => '請選擇國家',
          onChange: value => {
            if (value && !this.countryOptions.some(option => option.title === value)) {
              this.init = {
                ...this.init,
                ...this.filters,
                countries: ''
              }
            }
          }
        },
        {
          title: '資料類型',
          value: 'access_file_type',
          type: 'select',
          options: this.fileTypeOptions,
          placeholder: () => '請選擇資料格式'
        }
      ]
    },
    tableOptions () {
      return [
        {
          title: '操作時間',
          value: 'created_at',
          width: '150px',
          display: value => value ? dateFormat(new Date(value), 'yyyy/MM/dd hh:mm') : ''
        },
        {
          title: '使用者',
          value: 'user_display',
          width: '150px'
        },
        {
          title: '分析模組',
          value: 'module',
          width: '150px',
          display: value => (this.moduleOptions.find(option => option.value === value) || {}).title
        },
        {
          title: '年度',
          value: 'year',
          width: '100px'
        },
        {
          title: '產品名稱',
          value: 'product_name',
          width: '150px',
          display: value => value || '其他'
        },
        {
          title: '目標國',
          value: 'partner',
          width: '150px',
          display: value => ((this.countryOptions.find(option => option.value === value) || {}).country || {}).chinese_name
        },
        {
          title: '競爭國',
          value: 'country',
          width: '150px',
          display: value => ((this.countryOptions.find(option => option.value === value) || {}).country || {}).chinese_name
        },
        {
          title: '資料類型',
          value: 'access_file_type',
          display: value => (this.fileTypeOptions.find(option => option.value === value) || {}).title
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction',
      'setModalAction'
    ]),
    async fetchData () {
      await this.fetchProductByCategorys()
      await this.fetchAdminAccessLogs()
    },
    async fetchProductByCategorys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getProductByCategorys(config)
        let productByCategorys = response.data
        this.productByCategorys = productByCategorys
      } catch (error) {
        throw error
      }
    },
    async fetchAdminAccessLogs (filters) {
      try {
        let config = this.$ls.get('userInfo')
        filters = filters || this.filters || {}
        let data = {
          ...Object.entries(filters).filter(kv => kv[1]).reduce((s, kv) => ({ ...s, [kv[0]]: kv[1] }), {}),
          start_time: (filters.time || {})[0] ? (filters.time || {})[0] + ' 00:00' : (filters.time || {})[0],
          end_time: (filters.time || {})[1] ? (filters.time || {})[1] + ' 23:59' : (filters.time || {})[1],
          product_code: filters.product_code === '其他' ? '' : (filters.product_code || null),
          partner: (this.countryOptions.find(option => option.title === filters.partner) || {}).value || null,
          country: (this.countryOptions.find(option => option.title === filters.country) || {}).value || null
        }
        this.pageData.selectedPage && (data.page = this.pageData.selectedPage)
        this.pageData.display && (data.item_per_page = this.pageData.display)
        this.sort.value[0] && (data.order_by = this.sort.value[0])
        this.sort.order[0] && (data.order_method = this.sort.order[0].replace(/^-/, ''))
        let response = await getAdminAccessLogs(data, config)
        let accessLogs = response.data.data.elements
        this.pageData.total = response.data.data.items_count
        this.accessLogs = accessLogs.map(accessLog => ({
          ...accessLog,
          user_display: accessLog.user_name + (accessLog.user_occupation ? ' (' + accessLog.user_occupation + ')' : '')
        }))
      } catch (error) {
        throw error
      }
    },
    async searchDatas (init) {
      this.onSearch = true
      if (init) {
        this.init = init
        this.filter = init
      }
      await this.fetchAdminAccessLogs(init)
      this.onSearch = false
    },
    exportExcel () {
      let config = this.$ls.get('userInfo')
      let filters = this.filters
      let data = {
        ...config,
        ...Object.entries(filters).filter(kv => kv[1]).reduce((s, kv) => ({ ...s, [kv[0]]: kv[1] }), {}),
        time: null,
        start_time: (filters.time || {})[0],
        end_time: (filters.time || {})[1],
        product_code: filters.product_code === '其他' ? '' : (filters.product_code || null),
        partner: (this.countryOptions.find(option => option.title === filters.partner) || {}).value || null,
        country: (this.countryOptions.find(option => option.title === filters.country) || {}).value || null
      }
      let url = API_ROOT + 'admin/access_logs/export.xlsx'
      url = url + '?' + Object.entries(data).map(([key, value]) => value ? key + '=' + value : '').filter(x => x).join('&')
      downloadFile(null, url, '_target')
    },
    tableSortBy (value) {
      let position = this.sort.value.indexOf(value)
      if (position === 0) {
        let order =
          this.sort.order[position] === '-asc' ? '-desc' : '-asc'
        this.sort.order.splice(position, 1)
        this.sort.order.unshift(order)
      } else {
        let order =
          position !== -1
            ? this.sort.order[position] === '-asc' ? '-desc' : '-asc'
            : undefined
        position = position !== -1 ? position : 0
        this.sort.value.splice(position, 1)
        this.sort.order.splice(position, 1)
        this.sort.value.unshift(value)
        this.sort.order.unshift(order || '-asc')
      }
      this.searchDatas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/main/adminAccessLog.vue